import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CodSection from "./CodSection";
import PrepaidSection from "./PrepaidSection";
import SalesSheet from "./SalesSheet";
import { useLoader } from "../../../../utils/LoaderContext";

const ReportSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoading } = useLoader();

  const [activeTab, setActiveTab] = useState("cod");

  // ✅ Define tab list
  const tabList = [
    { key: "cod", label: "COD Orders", color: "bg-primary" },
    { key: "prepaid", label: "Prepaid Orders", color: "bg-primary" },
    { key: "salesheet", label: "Sales Sheet", color: "bg-primary" }, // 🔥 fixed key
  ];

  // ✅ Manage loader when switching tabs
  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timeout);
  }, [activeTab, setLoading]);

  // ✅ Sync tab with URL query
  useEffect(() => {
    const tabFromURL = new URLSearchParams(location.search).get("tab");
    if (tabFromURL) {
      setActiveTab(tabFromURL);
    } else {
      navigate("?tab=cod", { replace: true });
    }
  }, [location.search, navigate]);

  // ✅ Render content based on active tab
  const renderTable = () => {
    switch (activeTab) {
      case "cod":
        return <CodSection />;
      case "prepaid":
        return <PrepaidSection />;
      case "salesheet": // 🔥 fixed case
        return <SalesSheet />;
      default:
        return (
          <div className="text-center py-8 text-gray-500">
            Select a tab to view orders
          </div>
        );
    }
  };

  return (
    <div className="flex flex-col h-screen w-full">
      {/* Sticky Header */}
      <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
        <div className="w-full bg-white border-t">
          <div className="px-4 py-3">
            <div className="flex gap-2 overflow-x-auto hide-scrollbar scroll-smooth">
              {tabList.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => navigate(`?tab=${tab.key}`)}
                  className={`px-4 py-1 text-sm rounded border transition-all duration-200 whitespace-nowrap
                    ${
                      activeTab === tab.key
                        ? `${tab.color} text-white ring-2 ring-offset-1 ring-white`
                        : "text-primary bg-primaryLight hover:bg-primary hover:text-white border-primary"
                    }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-gray-50 overflow-hidden">
        <div className="h-full p-4 overflow-auto">
          <div className="max-w-full">{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default ReportSection;
